import { createContext } from "react";
import type { GridConfig } from "../../api/stock";

export const GridContext = createContext<[GridConfig[], (config: GridConfig | null, index?: number) => Promise<void>]>([[], () => Promise.resolve()]);